import { render, staticRenderFns } from "./SubjectPicker.vue?vue&type=template&id=aa80910a&"
import script from "./SubjectPicker.vue?vue&type=script&lang=js&"
export * from "./SubjectPicker.vue?vue&type=script&lang=js&"
import style0 from "./SubjectPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports